<template>
    <div class="box" style="" v-loading.fullscreen.lock="fullscreenLoading">
        <Navigation />
        <div class="c_box">
            <div style="height: 80px;"></div>
            
            <div class="ct_box">
                <h3 class="title">{{ Detail.title }}</h3>
                <div class="GuideDetail_ct">
                    <p v-html="Detail.content"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    created() { },
    mounted() {
        this.getDetail()
    },
    data() {
        return {
            fullscreenLoading: false,
            Detail: {}
        }
    },
    methods: {
        getDetail() {
            this.curlGet('/api/article/detail', {
                id: this.$route.query.id
            }).then(res => {
                // console.log(res);

                if (res.data.code == 1) this.Detail = res.data.data
                console.log(this.Detail);

            })
        }
    },
}
</script>

<style lang=scss scoped>
@import '../scss/Guide.scss'
</style>
<style>
.GuideDetail_ct p {
    font-size: 1.33rem;
    color: #333333;
}
</style>